import React from "react";

function CertificationItem({ certification, onEdit, onDelete }) {

return (
        <li key={certification.id} className="experience-item">
            <div className="experience-content">
                <div>
                    <strong>{certification.name}</strong> at {certification.organization}
                    <br />
                </div>
                <div className="experience-actions" style={{ marginTop: '10px' }}>
                    <i className="fa fa-pencil edit-icon" title="Edit" onClick={() => onEdit(certification)} style={{ cursor: 'pointer', marginRight: '10px' }}></i>
                    <i className="fa fa-trash delete-icon" title="Delete" onClick={() => onDelete(certification)} style={{ cursor: 'pointer' }}></i>
                </div>
            </div>
        </li>
    )
}

export default CertificationItem;